export const SliderArrowLeft = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 18 28" fill="none">
      <path
        d="M7.20033 14L17.9337 24.7333L14.667 28L0.666994 14L14.667 5.65058e-06L17.9337 3.26667L7.20033 14Z"
        fill="#283897"
      />
    </svg>
  )
}
